// share.js
import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const Share = () => {
  const [showCopied, setShowCopied] = useState(false);
  const handleCopyLink = () => {
    const link = "https://mponce.mdcvisual.digitalcard.store/";
    navigator.clipboard.writeText(link)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy link: ", err);
      });
  };

  return (
    <div style={{ position: "relative" }}>
      <button type="button" onClick={handleCopyLink} className="button-styles hover-text">
        <span className="tooltip-text fade">Share</span>
        <Icon icon="bi:share" />
      </button>
      {showCopied && (
        <div style={{
          position: "absolute",
          top: "calc(80% + 2px)",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2,
          width: "120px",
          whiteSpace: "nowrap",
          color: "var(--font-description-color)",
          fontSize: "12px",
          backgroundColor: "var(--tooltip-color)",
          borderRadius: "10px",
          padding: "6px 16px"
        }}>
          ¡Enlace copiado!
        </div>
      )}
    </div>
  );
};

export default Share;
